import api from "./axiosInterceptor"

const parseErrorResponse = async (err) => {
    const fallback = err?.message || "Error creating label";
    const data = err?.response?.data;
    if (!data) return { message: fallback, retryable: false };

    let text = data;
    if (data instanceof Blob) {
        text = await data.text();
    } else if (typeof data === "object" && !(data instanceof ArrayBuffer)) {
        return {
            message: data.message || data.error || fallback,
            retryable: Boolean(data.retryable),
        };
    }

    if (typeof text !== "string") {
        return { message: fallback, retryable: false };
    }

    try {
        const json = JSON.parse(text);
        return {
            message: json.message || json.error || text || fallback,
            retryable: Boolean(json.retryable),
        };
    } catch {
        return { message: text || fallback, retryable: /timeout|downstream duration/i.test(text) };
    }
};

export default async function PostPrintLabel(data, url) {
    try {
        const response = await api.post(`api/${url}`, data, {
            headers: {
                "Content-Type": "application/json",
            },
            responseType: "blob",
        });

        const contentType = response.headers?.["content-type"] || "";
        if (contentType.includes("application/json")) {
            const text = await response.data.text();
            const json = JSON.parse(text);
            return {
                data: null,
                error: {
                    message: json.message || "Error creating label",
                    retryable: Boolean(json.retryable),
                },
                load: false,
            };
        }

        if (response.status === 200) {
            const fileBlob = new Blob([response.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(fileBlob);
            return { data: fileURL, error: false, load: false };
        }

        return { data: null, error: { message: "Error creating label", retryable: false }, load: false };
    } catch (err) {
        const parsed = await parseErrorResponse(err);
        return { data: null, error: parsed, load: false };
    }
}
